/**
 * Load non-essential onsite marketing after the storefront is interactive.
 *
 * Shopify Customer Events, Google and Triple Whale remain under their existing
 * integrations and are deliberately not managed here. Klaviyo's Shopify app
 * and server-side sync remain installed; only its browser-side onsite bundle is
 * deferred. `_learnq` is created by non-datalayer-bridge.js, so events emitted
 * before this file loads are retained and drained by Klaviyo.
 */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'U6PhdU';
  var KLAVIYO_SRC =
    'https://static.klaviyo.com/onsite/js/' +
    KLAVIYO_COMPANY_ID +
    '/klaviyo.js';
  var loaded = false;
  var idleTimer;
  var interactionEvents = ['pointerdown', 'keydown', 'touchstart'];

  function cleanup() {
    interactionEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, loadKlaviyo, true);
    });
    if (idleTimer) window.clearTimeout(idleTimer);
  }

  function loadKlaviyo() {
    if (loaded || document.querySelector('script[src^="https://static.klaviyo.com/onsite/js/"]')) {
      cleanup();
      return;
    }

    loaded = true;
    cleanup();

    window._learnq = window._learnq || [];
    var script = document.createElement('script');
    script.async = true;
    script.src = KLAVIYO_SRC;
    script.dataset.nonDeferredMarketing = 'klaviyo';
    document.head.appendChild(script);
  }

  interactionEvents.forEach(function (eventName) {
    window.addEventListener(eventName, loadKlaviyo, { capture: true, once: true, passive: true });
  });

  // Preserve onsite identification and forms for visitors who pause to read,
  // while keeping the initial rendering window free of non-essential work.
  idleTimer = window.setTimeout(loadKlaviyo, 15000);
})();
